import { useEffect } from "preact/hooks";
import { ArtistDetail } from "../components/artists/ArtistDetail";
import { BackButton } from "../components/ui/BackButton";
import { ArtistDetailSkeleton } from "../components/ui/Skeleton";
import { useEdition } from "../hooks/useEdition";
import { useTranslations } from "../hooks/useTranslations";
import { useArtist } from "../hooks/useWidgetQueries";
import { useNavigation } from "../lib/router";

type ArtistDetailPageProps = {
  artistId: string;
  onNavigate: (path: string) => void;
  onBack: () => void;
};

export function ArtistDetailPage({
  artistId,
  onNavigate,
  onBack,
}: ArtistDetailPageProps) {
  const { editionId, edition } = useEdition();
  const t = useTranslations();
  const { toEvent } = useNavigation();
  const { data: artist, loading } = useArtist(artistId, editionId);

  useEffect(() => {
    if (artist && edition?.festival?.name) {
      document.title = `${artist.name} - ${edition.festival.name}`;
    }
  }, [artist, edition]);

  if (loading) {
    return (
      <div className="festapp-artist-detail-page">
        <BackButton onClick={onBack} />
        <ArtistDetailSkeleton />
      </div>
    );
  }

  if (!artist) {
    return (
      <div className="festapp-artist-detail-page">
        <BackButton onClick={onBack} />
        <div className="festapp-error">
          <p>{t.artistNotFound}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="festapp-artist-detail-page">
      <BackButton onClick={onBack} />
      <ArtistDetail
        artist={artist}
        onEventClick={(eventId) => onNavigate(toEvent(eventId))}
      />
    </div>
  );
}
